import { createSelector } from "@reduxjs/toolkit";

import { IUserSocialSecurityForm } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { buildData, dataSelector } from "../helpers";

export const userSocialSecurityFormsSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.userSocialSecurityForm) as IUserSocialSecurityForm[]
);

const dataUserSocialSecurityFormsSelector = createSelector(
  dataSelector,
  data => data.userSocialSecurityForm
);

export const userSocialSecurityFormSelectorCreator = (id: string) =>
  createSelector(dataUserSocialSecurityFormsSelector, data => {
    const item = data?.[API_ENDPOINTS.USER_SOCIAL_SECURITY_FORM(id)];
    return item ? (buildSingleItem(item) as IUserSocialSecurityForm) : undefined;
  });
